// extracted by mini-css-extract-plugin
export const active = "TextField__active__bYrCW";
export const atlasGrotesk = "'AtlasGrotesk'";
export const bold = "700";
export const decoration = "TextField__decoration__4dmap";
export const disabled = "TextField__disabled__m5y1l";
export const ellipsisDark = "TextField__ellipsisDark__EsFJ6";
export const ellipsisGray = "TextField__ellipsisGray__FKAJU";
export const ellipsisSnow = "TextField__ellipsisSnow__ACK9d";
export const error = "TextField__error__Q8bjH";
export const errorList = "TextField__errorList__tvm6i";
export const errorListItem = "TextField__errorListItem__yJLrF";
export const errorsWrapper = "TextField__errorsWrapper__mLqD9 font-faces__sansRegular__c8KXl font-faces__sans__uCf65";
export const green = "TextField__green__3Y1bD";
export const guideline = "TextField__guideline__GzyXm";
export const headBgColorExternal = "var(--salt)";
export const headBgColorInternal = "var(--shade)";
export const headBgColorShrunkSidebar = "var(--slate)";
export const input = "TextField__input__LP4VK font-faces__sansRegular__c8KXl font-faces__sans__uCf65";
export const inputWrapper = "TextField__inputWrapper__6mY7b";
export const label = "TextField__label__Al9yK font-faces__sansRegular__c8KXl font-faces__sans__uCf65";
export const labelText = "TextField__labelText__q8Gf-";
export const labelWrapper = "TextField__labelWrapper__O42l3";
export const medium = "500";
export const multipleErrors = "TextField__multipleErrors__hTzW4";
export const red = "TextField__red__tUwlX";
export const regular = "400";
export const rule = "TextField__rule__gQaTz";
export const ruleCheckmark = "TextField__ruleCheckmark__Nf-60";
export const ruleDot = "TextField__ruleDot__MwZ5X";
export const sans = "'sans'";
export const semibold = "600";
export const serif = "'serif'";
export const showLabelAsLink = "TextField__showLabelAsLink__odmLh";
export const singleError = "TextField__singleError__TVfh8";
export const textBoxSpinner = "TextField__textBoxSpinner__NvVpo";
export const textSecurity = "TextField__textSecurity__3PJP9";
export const textbox = "TextField__textbox__qnJkJ";
export const textboxInner = "TextField__textboxInner__H2UxG";
export const tooltipIconWrapper = "TextField__tooltipIconWrapper__pQtmg TooltipIcon__tooltipIconWrapper__oUGNC";
export const validRule = "TextField__validRule__uNYny";
export const withEllipsis = "TextField__withEllipsis__0PEPY";
export const withValue = "TextField__withValue__dyoqx";
export const yellow = "TextField__yellow__AhPKP";